import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { initApplication } from '@/core/utils/application';

import './App.scss';

// Defer importing modules that rely on window.rapidstor_settings until after initApplication
// has populated the global configuration to avoid "undefined" access errors.
const bootstrap = async () => {
    const container = document.getElementById('rapidstor-v2-frontend');
    try {
        await initApplication();

        // Import store first (ensuring its side-effects register before router loads).
        const { default: store } = await import('@/store');
        // Only once store is ready, import the router (which depends on store and global config)
        const { createAppRouter } = await import('@/core/router');
        const router = createAppRouter();

        ReactDOM.createRoot(container as HTMLElement).render(
            <React.StrictMode>
                <Provider store={store}>
                    <RouterProvider router={router} />
                </Provider>
            </React.StrictMode>,
        );

        // Resolve build-time `data-rs-setting-dynamic` markers to the final
        // `data-rs-setting` attribute for text actually sourced from settings, so
        // Automate's translate inspector can flag it. Deferred like the imports
        // above since it reads window.rapidstor_settings. Scoped to document.body
        // (not the app root) so modals portaled to body — ContactCard,
        // DetailsModal — are covered too.
        const { installSettingsTextMarker } = await import(
            '@/core/utils/settingsTextMarker'
        );
        installSettingsTextMarker(document.body);
    } catch (err) {
    // eslint-disable-next-line no-console
        console.error('Failed to bootstrap application', err);
        if (container) {
            container.innerHTML = '<div style="padding:1rem;font-family:system-ui,Arial,sans-serif;color:#b00;">Failed to load application configuration.</div>';
        }
    }
};

bootstrap();
